<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            Parameter
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow v-if="$helper.isRole($availRoles['HO'])">
      <CCol>
        <CCard class="custom-card">
          <CCardBody class="p-0">
            <b-table striped hover show-empty
              responsive="xl"
              :items="configParameterTable.items"
              :fields="configParameterTable.fields"
              :busy="!configParameterTable.isLoaded"
              no-local-sorting no-sort-reset
            >
              <template slot="empty">
                <div v-if="!configParameterTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(valueType)="row">
                {{ row.value == 1 ? 'Number' : 'String' }}
              </template>
              <template #cell(value)="row">
                <b-input-group>
                  <b-input-group-prepend>
                    <template v-if="row.item.valueType == 1">
                      <b-form-input
                        :value="$helper.thousandSeparator(row.item.valueNumber)"
                        v-if="row.item.display == 'NOTARY_CONTRACT_MAX_AGE' || row.item.display == 'CONTRACT_ASSIGNMENT_TIME'"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        @input="row.item.valueNumber = $event.toString().replace(/\./g, '')"
                        maxlength="3"
                        type="text"
                        placeholder="Value"
                        autocomplete="off"
                        style="max-width: 200px;"
                        @blur="onBlurValue(row.item.id)"
                      ></b-form-input>
                      <b-form-input
                        :value="$helper.thousandSeparator(row.item.valueNumber)"
                        v-else
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        @input="row.item.valueNumber = $event.toString().replace(/\./g, '')"
                        maxlength="19"
                        type="text"
                        placeholder="Value"
                        autocomplete="off"
                        style="max-width: 200px;"
                        @blur="onBlurValue(row.item.id)"
                      ></b-form-input>
                    </template>
                    <b-form-input
                      v-else
                      v-model="row.item.valueString"
                      maxlength="50"
                      type="text"
                      placeholder="Value"
                      autocomplete="off"
                      style="max-width: 200px;"
                      @blur="onBlurValue(row.item.id)"
                    ></b-form-input>
                  </b-input-group-prepend>
                  <b-input-group-append class="ml-3 pt-2">
                    <b-spinner small label="Updating..." v-if="row.item.isLoading"></b-spinner>
                    <transition name="fade" mode="out-in" v-else>
                      <b-icon icon="check-circle-fill" scale="1.5" variant="success" v-if="row.item.checked"></b-icon>
                      <b-icon icon="x-circle-fill" scale="1.5" variant="danger" v-else-if="row.item.checked === false"></b-icon>
                    </transition>
                  </b-input-group-append>
                </b-input-group>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="configParameterTable.totalRows" :page="configParameterTable.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'ConfigParameterList',
  data() {
    return {
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      configParameterTable: {
        isLoaded: false,
        fields: [
          {key: "display", label: "Parameter Name", sortable: false},
          {key: "valueType", label: "Tipe Data", sortable: false},
          {key: "value", label: "Parameter Value", sortable: false}
        ],

        items: [],

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    onBlurValue(id) {
      let selectedObj = {}
      this.configParameterTable.items.forEach(obj => {
        if (obj.id == id) selectedObj = obj
      })
      selectedObj.isLoading = true
      selectedObj.checked = null
      selectedObj.valueNumber = this.$helper.normalizedNumber(selectedObj.valueNumber)

      let currentValue = (selectedObj.valueType == 1) ? selectedObj.valueNumber : selectedObj.valueString

      if (currentValue != selectedObj.prevValue) {
        let postUrl = '/parameter/edit/'
        let obj = selectedObj
        this.$axios.post(postUrl, obj).then(response => {
          if(response.status == 200){
            selectedObj.checked = true
            selectedObj.prevValue = currentValue

          } else{
            selectedObj.checked = false
            this.$helper.toastError(this, "Update Parameter Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Update Parameter Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Update Parameter Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          selectedObj.isLoading = false
        })
      } else{
        selectedObj.isLoading = false
      }
    },

    onLimitChange(newPerPage) {
      this.configParameterTable.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getConfigParameterTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getConfigParameterTableItems(newPage)
      }
    },

    getConfigParameterTableItems(page = 1) {
      this.configParameterTable.isLoaded = false
      this.configParameterTable.items = []
      if(isNaN(page)) {
        this.configParameterTable.currentPage = 1
      }
      else {
        this.configParameterTable.currentPage = page
      }
      // URL builder
      let getUrl = "/parameter/getAll"

      let params = this.$helper.getBasePagedQuery(this.configParameterTable.currentPage - 1, this.configParameterTable.perPage)

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.configParameterTable.items = response.data.data.data.map(obj => {
            
            obj.checked = null
            obj.isLoading = false
            obj.prevValue = obj.valueType == 1 ? obj.valueNumber : obj.valueString
            obj.valueNumber = (this.$helper.isEmpty(obj.valueNumber) ? obj.valueNumber : obj.valueNumber)

            return obj
          })
          this.configParameterTable.totalRows = response.data.data.totalElements
          this.configParameterTable.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Parameter Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Parameter Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Parameter Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.configParameterTable.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

    // thousandSeparated(index) {
    //   let temp = ''
    //   temp = this.configParameterTable.items[index].valueNumber
    //   if (this.$helper.isEmpty(temp)) return

    //   temp = temp.toString().replace(/\./g, "")
    //   temp = this.$helper.thousandSeparator(temp)

    //   this.configParameterTable.items[index].valueNumber = temp

    //   this.$forceUpdate()
    // },

  },

  created(){
    this.getConfigParameterTableItems()
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>